import { DataManager } from '@syncfusion/ej2-data';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { ExportInterfaceConfigurationType, ExportInterfaceFieldAssignmentTemplateDTO } from 'src/app/base/models/models.swagger.generated';
import { SpinnerService } from 'src/app/base/spinner/spinner.service';
import { AvpCustomAdaptor } from 'src/app/base/shared/syncfusion/avp-custom-adaptor';
import { RecordDoubleClickEventArgs, RowSelectEventArgs, GridModule } from '@syncfusion/ej2-angular-grids';
import { FieldAssignmentTemplatesOverviewService } from './field-assignment-templates-overview.service';
import { ModalService } from '../../../../base/shared/modal/modal.service';
import { UntypedFormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ConfigurationsService } from '../../configurations/configurations.service';
import { QueryBuilderModule } from '@syncfusion/ej2-angular-querybuilder';
import { GridBaseComponent } from 'src/app/base/shared/grid-base/grid-base.component';

@Component({
    selector: 'app-field-assignment-templates-overview',
    templateUrl: './field-assignment-templates-overview.component.html',
    styleUrls: ['./field-assignment-templates-overview.component.scss'],
    imports: [
        GridModule,
        QueryBuilderModule,
        TranslateModule,
    ]
})
export class FieldAssignmentTemplatesOverviewComponent extends GridBaseComponent<any> implements OnInit, OnDestroy {
  @Output() rowSelected = new EventEmitter<ExportInterfaceFieldAssignmentTemplateDTO>();
  @Output() recordDoubleClick = new EventEmitter<ExportInterfaceFieldAssignmentTemplateDTO>();

  @Input() public templateForm: UntypedFormGroup;
  @Input() public isStandalone: boolean = false;
  @Input() public set selectedTemplateId(value: number) {
    if (value !== this._selectedTemplateId) {
      this._selectedTemplateId = value;
      if (value !== null && value !== undefined) {
        this.grid?.selectRows([this.grid.getRowIndexByPrimaryKey(value)]);
      } else {
        this.grid?.selectRows([]);
      }
    }
  }

  private addedRecordId: number = null;
  private previousRowIndex: number;
  private _subscription: Subscription = new Subscription();
  private _selectedTemplateId: number;

  constructor(
    translateService: TranslateService,
    protected templatesService: FieldAssignmentTemplatesOverviewService,
    private spinnerService: SpinnerService,
    private modalService: ModalService,
    private configurationsService: ConfigurationsService,
  ) {
    super(translateService, templatesService);
  }

  ngOnDestroy(): void {
    this._subscription?.unsubscribe();
    this.templatesService.configurationType = null;
  }

  ngOnInit() {
    this.templatesService.doIgnoreTypeFilter = this.isStandalone;
    this.isActiveColumnName = 'Active';
    this.data = new DataManager({
      adaptor: new AvpCustomAdaptor(this.templatesService, this.spinnerService),
    });
    if(this.isStandalone) {
      this.templatesService.configurationType = null;
    } else {
      this.templatesService.configurationType = this.configurationsService.configurationType;
    }
    this.refresh();
    this.templatesService.oneTimeFilterTemplateId = this._selectedTemplateId;
  }

  public onRecordDoubleClick(args: RecordDoubleClickEventArgs): void {
    const data = args.rowData as ExportInterfaceFieldAssignmentTemplateDTO;
    if (data) {
      this.recordDoubleClick.emit(data);
    }
  }

  public getTypeName(type: number): string {
    return 'i18n.shared.configurationTypes.' + ExportInterfaceConfigurationType[type];
  }

  public recordAdded(id: number) {
    this.addedRecordId = id;
    this.grid.refresh();
  }

  public onDataBound() {
    if (this.addedRecordId) {
      const index = this.grid?.getRowIndexByPrimaryKey(this.addedRecordId);
      this.grid?.selectRow(index);
      this.addedRecordId = null;
      if (this.previousRowIndex >= index) {
        this.previousRowIndex += 1;
      }
    }
    if (this._selectedTemplateId && this.grid?.selectedRowIndex < 0) {
      const index = this.grid?.getRowIndexByPrimaryKey(this._selectedTemplateId);
      this.grid?.selectRow(index);
    }
  }

  public refresh(): void {
    this.grid?.refresh();
  }

  public onRowSelected(args: RowSelectEventArgs): void {
    if (this.templateForm?.dirty) {
      const dialog = this.modalService.showOkCancelDialog('i18n.domain.export-configuration.field-assignment-templates.discard-dialog.title', 'i18n.domain.export-configuration.field-assignment-templates.discard-dialog.question');
      dialog.onOkSubject.subscribe(() => {
        const data = args.data as ExportInterfaceFieldAssignmentTemplateDTO;
        if (data) {
          this._selectedTemplateId = data.id;
          this.rowSelected.emit(data);
          this.previousRowIndex = this.grid?.selectedRowIndex;
        }
      });
      dialog.onCancelSubject.subscribe(() => {
        this.grid.selectRows([this.previousRowIndex]);
      });
    } else {
      const data = args.data as ExportInterfaceFieldAssignmentTemplateDTO;
      if (data) {
        this._selectedTemplateId = data.id;
        this.rowSelected.emit(data);
        this.configurationsService.configurationType = data.configurationType;
        this.previousRowIndex = this.grid?.selectedRowIndex;
      }
    }
  }

  public resetRowSelected(): void {
    if (this.grid?.selectedRowIndex >= 0) {
      this.grid.selectRows([]);
    }
  }

  protected initializeEditForm(data: ExportInterfaceFieldAssignmentTemplateDTO): void {
    throw new Error('Method not implemented.');
  }

  protected getEditDialogTitleParams(rowData: any): object {
    throw new Error('Method not implemented.');
  }

}
